import { useState, useEffect } from "react";
import _ from "lodash";

import TimesheetViewMode from "./TimesheetViewMode";
import DayIndicator from "./DayIndicator";
import TotalTimesheet from "./TotalTimesheet";
import DayTimesheet from "./DayTimesheet";
import TechnicianService from "src/Services/API/technician.service";
import { handleError } from "src/Common/function";

const Timesheet = ({ order }) => {
  const [viewMode, setViewMode] = useState("total");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [timesheetData, setTimesheetData] = useState([]);

  const getTimesheetData = () => {
    TechnicianService.getTimesheetByWoId(order.id)
      .then((response) => {
        if (response.status == 200) {
          let assignedTechs = _.cloneDeep(response.data);
          for (let i = 0; i < assignedTechs.length; i++) {
            if (assignedTechs[i].timesheet) {
              assignedTechs[i].timesheet = JSON.parse(assignedTechs[i].timesheet);
              assignedTechs[i].totalTimesheet = JSON.parse(
                assignedTechs[i].totalTimesheet
              );
            }
          }
          setTimesheetData(assignedTechs);
        }
      })
      .catch((error) => handleError(error));
  };

  useEffect(() => {
    getTimesheetData();
  }, [order]);

  return (
    <div>
      <div className="flex items-center justify-between">
        <TimesheetViewMode value={viewMode} onChange={setViewMode} />
        <div className="flex items-center justify-center flex-auto">
          <DayIndicator
            startDateString={order.startDateString}
            viewMode={viewMode}
            currentDateChanged={setCurrentDate}
            timesheetData={timesheetData}
          />
        </div>
      </div>
      {viewMode === "total" ? (
        <TotalTimesheet
          timesheetData={timesheetData}
          currentDate={currentDate}
          startDateString={order.startDateString}
        />
      ) : (
        <DayTimesheet
          timesheetData={timesheetData}
          currentDate={currentDate}
          startDateString={order.startDateString}
          timesheetUpdated={getTimesheetData}
          woStatus={order.status}
        />
      )}
    </div>
  );
};

export default Timesheet;